<script>
import DatePicker from 'vue-datepicker-next';
import NextButton from 'dashboard/components-next/button/Button.vue';

export default {
  components: {
    DatePicker,
    NextButton,
  },
  emits: ['close', 'schedule'],
  data() {
    return {
      scheduledAt: null,
      lang: {
        days: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
        yearFormat: 'YYYY',
        monthFormat: 'MMMM',
      },
    };
  },
  computed: {
    canSubmit() {
      return this.scheduledAt && new Date(this.scheduledAt) > new Date();
    },
  },
  methods: {
    onClose() {
      this.$emit('close');
    },
    onSchedule() {
      if (!this.canSubmit) return;
      this.$emit('schedule', this.scheduledAt);
    },
    disabledDate(date) {
      const yesterday = new Date();
      yesterday.setDate(yesterday.getDate() - 1);
      return date < yesterday;
    },
    disabledTime(date) {
      const now = new Date();
      return date < now;
    },
  },
};
</script>

<template>
  <div class="flex flex-col">
    <woot-modal-header
      :header-title="$t('CONVERSATION.SCHEDULED_MESSAGE.TITLE')"
    />
    <form
      class="modal-content w-full pt-2 px-5 pb-6"
      @submit.prevent="onSchedule"
    >
      <DatePicker
        v-model:value="scheduledAt"
        type="datetime"
        inline
        input-class="mx-input "
        :lang="lang"
        :disabled-date="disabledDate"
        :disabled-time="disabledTime"
      />
      <div class="flex flex-row justify-end w-full gap-2 px-0 py-2">
        <NextButton
          faded
          slate
          type="reset"
          :label="$t('CONVERSATION.SCHEDULED_MESSAGE.CANCEL')"
          @click.prevent="onClose"
        />
        <NextButton
          type="submit"
          :disabled="!canSubmit"
          :label="$t('CONVERSATION.SCHEDULED_MESSAGE.CONFIRM')"
        />
      </div>
    </form>
  </div>
</template>
